import React from 'react';

const Badge = ({ text, color = 'green' }) => {
  const colorClasses = {
    green: 'bg-green-50 text-green-700',
    red: 'bg-red-50 text-red-700'
  };

  return (
    <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${colorClasses[color]}`}>
      {text}
    </span>
  );
};

export default Badge;
